<!-- components/Loading.vue -->
<template>
    <div class="flex justify-center items-center min-h-screen">
      <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-green"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingView',
  };
  </script>
  
  <style scoped>
  .spinner-border {
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: currentColor;
  }
  </style>
  